import {Component, OnInit, ViewChild} from '@angular/core';
import {ApiService} from '../../../shared/services/api.service';
import {Contact} from '../../../entities';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {ContactLog} from '../../../entities/contact-log.model';
import { JhiLanguageService } from 'ng-jhipster';

@Component({
  selector: 'app-marketwebsite-merchants',
  templateUrl: './marketwebsite-merchants.component.html',
  styles: []
})
export class MarketwebsiteMerchantsComponent implements OnInit {

  public loading = false;
  public notFoundError = false;
  public merchantNumber: string;
  public contact: Contact;
  public banLog = new ContactLog();
  public contactLogs: Array<ContactLog> = [];
  public modalRef = null;
  public showHistory = false;

  @ViewChild('banModal') private banModal;
  @ViewChild('unbanModal') private unbanModal;

  constructor(
    private apiService: ApiService,
    private modalService: NgbModal,
    private jhiLanguageService: JhiLanguageService
  ) {
    this.jhiLanguageService.setLocations(['home']);
  }

  ngOnInit() {

  }


  searchMerchant() {
    this.contact = null;
    if (this.merchantNumber !== null && this.merchantNumber !== '') {

      this.apiService.find<Contact>(Contact, 'contacts-by-merchant-number/' + this.merchantNumber).subscribe(contacts => {
        if (contacts.length > 0) {
          const companyContact = contacts.filter((entry) => (entry.casIsCompany));
          if (companyContact != null && companyContact.length > 0) {
            this.contact = companyContact[0];

            this.apiService.find<ContactLog>(ContactLog, 'contact-logs-by-contact/' + this.contact.id).subscribe(contactLogs => {
              this.contactLogs = contactLogs.sort( (cl1, cl2) => {
                if (cl1.created > cl2.created) {
                  return -1;
                }
                if (cl1.created < cl2.created) {
                  return 1;
                }
                if (cl1.created === cl2.created) {
                  return 0;
                }
              });
            });

          }
        }
        this.notFoundError = false;
        this.loading = false;
      }, error => {this.notFoundError = true; this.loading = false; });
    }
  }

  banMerchant() {
    this.banLog.actionType = ContactLog.ACTION_TYPE_BAN_MERCHANT_FROM_MARKETWEBSITE;
    this.updateBan();
  }

  unbanMerchant() {
    this.banLog.actionType = ContactLog.ACTION_TYPE_UNBAN_MERCHANT_FROM_MARKETWEBSITE;
    this.updateBan();
  }

  banMerchantConfirmation() {
    this.modalRef = this.modalService.open(this.banModal, {backdrop: 'static'});
  }

  private updateBan() {
    this.banLog.contact = this.contact;
    this.apiService.post(this.banLog, 'ban-merchant-from-marketwebsite').subscribe(
      result => {
        this.searchMerchant();
      }
    );
  }

  unbanMerchantConfirmation() {
    this.modalRef = this.modalService.open(this.unbanModal, {backdrop: 'static'});
  }
}



// WEBPACK FOOTER //
// ./src/app/administration/components/marketwebsite-merchants/marketwebsite-merchants.component.ts